<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Live Class Teacher' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Live Class Teacher</h3>
        <v-card>
            <v-autocomplete
                id="select_teacher"
                v-model="teacher"
                :items="teachers"
                item-text="name"
                item-value="id"
                height="36px"
                placeholder="Pilih Guru"
                class="select_box mx-2 my-2 pt-5"
                v-on:change="chooseTeacher(teacher)"
                outlined
                hide-details
            ></v-autocomplete>
            <div :class="$vuetify.breakpoint.mdAndUp ? 'mt-5 ml-2' : ''">
                <v-btn
                    v-if="$vuetify.breakpoint.mdAndUp"
                    height="40"
                    rounded
                    depressed
                    color="touchblue"
                    @click="dialogDate = true"
                >
                    <span class="blew--text">
                        <v-icon color="blew" small>mdi-calendar-today</v-icon>
                        &nbsp;
                        {{ moment(selectedDay).format("MMM DD, YYYY") }}
                        &nbsp;
                        <v-icon color="blew" small> mdi-chevron-down </v-icon>
                    </span>
                </v-btn>
                <v-btn
                    v-else
                    depressed
                    block
                    tile
                    color="touchblue"
                    @click="dialogDate = true"
                >
                    <div class="d-flex align-center blew--text">
                        <div class="text-left">
                            <v-icon color="blew" small>
                                mdi-calendar-today
                            </v-icon>
                            &nbsp;
                            {{ moment(selectedDay).format("MMM DD, YYYY") }}
                        </div>
                        <v-spacer />
                        <div class="text-right">
                            <v-icon color="blew" small>
                                mdi-chevron-down
                            </v-icon>
                        </div>
                    </div>
                </v-btn>
            </div>

            <v-dialog
                v-model="dialogDate"
                max-width="320"
                @click:outside="nowday = selectedDay"
                @keydown.esc="nowday = selectedDay"
            >
                <v-card>
                    <v-date-picker
                        v-model="nowday"
                        no-title
                        full-width
                        color="primary"
                        :weekday-format="getDay"
                        :show-current="moment().format('YYYY-MM-DD')"
                        locale="id"
                        first-day-of-week="1"
                        prev-icon="mdi-chevron-left"
                        next-icon="mdi-chevron-right"
                    ></v-date-picker>
                    <v-card-actions>
                        <v-row dense>
                            <v-col cols="6">
                                <v-btn
                                    color="darkerfadedblue"
                                    text
                                    rounded
                                    block
                                    large
                                    depressed
                                    @click="
                                        ((nowday = selectedDay),
                                        (dialogDate = false))
                                    "
                                    >Batal</v-btn
                                >
                            </v-col>
                            <v-col cols="6">
                                <v-btn
                                    color="primary"
                                    rounded
                                    block
                                    large
                                    depressed
                                    @click="
                                        ((selectedDay = nowday),
                                        (dialogDate = false))
                                    "
                                    >Terapkan</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-card
                outlined
                :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
                :tile="$vuetify.breakpoint.smAndDown"
            >
                <v-card-text
                    :class="$vuetify.breakpoint.smAndDown ? ' pa-0' : 'py-1'"
                >
                    <v-carousel
                        height="100%"
                        light
                        next-icon="mdi-chevron-right"
                        prev-icon="mdi-chevron-left"
                        hide-delimiter-background
                        hide-delimiters
                        :show-arrows="$vuetify.breakpoint.mdAndUp"
                        touchless
                    >
                        <template v-slot:prev="{ attrs }">
                            <v-btn
                                fab
                                depressed
                                small
                                color="#f4f9f9"
                                width="24"
                                height="24"
                                v-bind="attrs"
                                @click="
                                    ((startweek = moment(startweek).subtract(
                                        1,
                                        'week',
                                    )),
                                    keyaweek++)
                                "
                                ><v-icon> mdi-chevron-left</v-icon></v-btn
                            >
                        </template>
                        <template v-slot:next="{ attrs }">
                            <v-btn
                                fab
                                small
                                depressed
                                color="#f4f9f9"
                                v-bind="attrs"
                                width="24"
                                height="24"
                                @click="
                                    ((startweek = moment(startweek).add(
                                        1,
                                        'week',
                                    )),
                                    keyaweek++)
                                "
                                ><v-icon> mdi-chevron-right</v-icon></v-btn
                            >
                        </template>
                        <v-carousel-item v-for="(left, i) in 1" :key="i">
                            <transition
                                name="scroll-x-transition"
                                mode="out-in"
                            >
                                <!-- ... the buttons ... -->
                                <v-item-group
                                    :key="keyaweek"
                                    v-touch="{
                                        left: () => swipe(0),
                                        right: () => swipe(1),
                                    }"
                                    mandatory
                                >
                                    <v-container fluid>
                                        <v-row class="no-gutters">
                                            <v-col
                                                v-for="(n, i) in aweek"
                                                :key="i"
                                                :class="
                                                    $vuetify.breakpoint.mdAndUp
                                                        ? 'mx-5'
                                                        : 'mx-0'
                                                "
                                            >
                                                <v-item v-slot="{ toggle }">
                                                    <v-card
                                                        :color="
                                                            selectedDay == n
                                                                ? 'blew'
                                                                : 'transparent'
                                                        "
                                                        class="d-flex mx-auto flex-column text-center"
                                                        flat
                                                        :width="
                                                            $vuetify.breakpoint
                                                                .smAndDown
                                                                ? ''
                                                                : '70'
                                                        "
                                                        height="50"
                                                        @click="
                                                            (toggle,
                                                            (selectedDay = n))
                                                        "
                                                    >
                                                        <div class="my-auto">
                                                            <div
                                                                class="roboto-text font-weight-500 text-center"
                                                                :class="
                                                                    selectedDay ==
                                                                    n
                                                                        ? 'white--text'
                                                                        : 'fadedblue--text'
                                                                "
                                                                :style="
                                                                    $vuetify
                                                                        .breakpoint
                                                                        .smAndDown
                                                                        ? ' font-size: 10px'
                                                                        : ' font-size: 14px'
                                                                "
                                                                style="
                                                                    font-size: 14px;
                                                                "
                                                            >
                                                                {{
                                                                    moment(
                                                                        n,
                                                                    ).format(
                                                                        "dddd",
                                                                    )
                                                                }}
                                                            </div>
                                                            <div
                                                                class="roboto-text font-weight-700 text-center"
                                                                :class="
                                                                    selectedDay ==
                                                                    n
                                                                        ? 'white--text'
                                                                        : 'grey2--text'
                                                                "
                                                                :style="
                                                                    $vuetify
                                                                        .breakpoint
                                                                        .smAndDown
                                                                        ? ' font-size: 14px'
                                                                        : ' font-size: 18px'
                                                                "
                                                            >
                                                                {{
                                                                    moment(
                                                                        n,
                                                                    ).format(
                                                                        "DD",
                                                                    )
                                                                }}
                                                            </div>
                                                        </div>
                                                    </v-card>
                                                </v-item>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-item-group>
                            </transition>
                        </v-carousel-item>
                    </v-carousel>
                </v-card-text>
                <v-card-text class="border-top-1 pa-1">
                    <v-sheet
                        style="overflow-y: auto; overflow-x: hidden"
                        height="70vh"
                        width="100%"
                        class="timeline-class"
                    >
                        <v-fade-transition mode="out-in">
                            <div v-if="loading">
                                <v-timeline
                                    align-top
                                    style="min-height: 100%"
                                    dense
                                >
                                    <v-timeline-item
                                        v-for="index in 3"
                                        :key="index"
                                        :color="'fadedblue'"
                                        fill-dot
                                        icon="mdi-circle-outline"
                                        small
                                    >
                                        <template v-slot:opposite>
                                            <span
                                                :class="'fadedblue--text'"
                                                :style="
                                                    $vuetify.breakpoint
                                                        .smAndDown
                                                        ? 'font-size: 12px'
                                                        : ''
                                                "
                                                class="font-weight-bold"
                                            ></span>
                                        </template>
                                        <v-row style="margin-top: 3px">
                                            <v-col
                                                md="6"
                                                cols="11"
                                                class="pt-0 cursor-pointer"
                                            >
                                                <v-card outlined>
                                                    <v-skeleton-loader
                                                        type="image"
                                                    />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-timeline-item>
                                </v-timeline>
                            </div>
                            <v-sheet
                                v-else-if="!loading && premiclasses.length < 1"
                                color="transparent"
                                class="mx-auto mt-5 text-center d-flex flex-column fill-height"
                                :width="
                                    $vuetify.breakpoint.smAndDown
                                        ? '80vw'
                                        : '400'
                                "
                                height="50vh"
                            >
                                <v-img
                                    width="324"
                                    height="150"
                                    class="mx-auto"
                                    :src="require('@/assets/no_class.svg')"
                                    contain
                                ></v-img>
                                <div class="roboto-text font-weight-700">
                                    Tidak ada data kelas
                                </div>
                            </v-sheet>
                            <v-timeline
                                v-else-if="premiclasses.length > 0"
                                align-top
                                style="min-height: 100%"
                                dense
                            >
                                <v-timeline-item
                                    v-for="(item, index) in premiclasses"
                                    :key="index"
                                    :color="
                                        item.statusLive ? '#50559F' : '#AFB6C9'
                                    "
                                    fill-dot
                                    icon="mdi-circle-outline"
                                    small
                                >
                                    <template v-slot:opposite>
                                        <span
                                            :class="
                                                item.statusLive
                                                    ? 'blueple--text'
                                                    : 'fadedblue--text'
                                            "
                                            :style="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'font-size: 12px'
                                                    : ''
                                            "
                                            class="font-weight-bold"
                                            >{{
                                                moment(item.startAt).format(
                                                    "HH:mm",
                                                )
                                            }}</span
                                        >
                                    </template>
                                    <v-row style="margin-top: 3px">
                                        <v-col
                                            md="6"
                                            cols="11"
                                            class="pt-0 cursor-pointer"
                                        >
                                            <v-card
                                                outlined
                                                :style="
                                                    !item.statusLive
                                                        ? 'background-color:#FBFBFB; border-color: #EBEBEB'
                                                        : ''
                                                "
                                                :color="
                                                    item.statusLive
                                                        ? '#50559F'
                                                        : ''
                                                "
                                                :dark="item.statusLive"
                                                @click="checklive(item)"
                                            >
                                                <v-card-text>
                                                    <!-- <v-btn
                            v-if="item.statusLive"
                            absolute
                            top
                            right
                            depressed
                            x-small
                            color="#FF647C"
                            dark
                          >
                            <svg
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="4" cy="4" r="4" fill="white" />
                            </svg>
                            &nbsp;LIVE
                          </v-btn> -->

                                                    <div
                                                        :class="
                                                            item.statusLive
                                                                ? 'monochrome--text'
                                                                : 'grey7--text'
                                                        "
                                                        class="roboto-text font-weight-400"
                                                        style="font-size: 13px"
                                                    >
                                                        {{ item.subject }}
                                                    </div>
                                                    <div
                                                        :class="
                                                            item.statusLive
                                                                ? 'monochrome--text'
                                                                : 'grey7--text'
                                                        "
                                                        class="roboto-text font-weight-700"
                                                        style="font-size: 14px"
                                                    >
                                                        {{ item.name }}
                                                    </div>
                                                    <div
                                                        :class="
                                                            item.statusLive
                                                                ? 'monochrome--text'
                                                                : 'grey7--text'
                                                        "
                                                        class="roboto-text font-weight-400"
                                                        style="font-size: 13px"
                                                    >
                                                        {{ item.teachers }}
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-timeline-item>
                            </v-timeline>
                        </v-fade-transition>
                    </v-sheet>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>

<script>
import _ from "lodash-es";
import LiveClassTeacherService from "@/modules/live_class_teacher/services/liveclassteacher.js";
import moment from "moment";

export default {
    name: "live-class-teacher",

    data: function () {
        return {
            loading: false,
            moment: moment,
            live: false,
            teacher: null,
            teachers: [],
            semuakelas: [],
            classes: [],
            allclass: [
                {
                    id: "1",
                },
            ],
            liveclasses: [],
            keyaweek: 0,
            selectedDay: moment().format("YYYY-MM-DD"),
            startweek: moment().startOf("week"),
            nowday: moment().format("YYYY-MM-DD"),
            startDay: 0,
            changedOnDate: false,
            dialogDate: false,
            daysOfWeek: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
            selectedClass: {},
            selected: 0,
            lcrId: "",
            premiclass: [
                {
                    started: true,
                },
                {
                    started: false,
                },
                {
                    started: true,
                },
                {
                    started: false,
                },
                {
                    started: false,
                },
                {
                    started: true,
                },
            ],
        };
    },

    watch: {
        aweek() {
            if (!this.changedOnDate) {
                const [formatted] = this.aweek;
                this.selectedDay = moment(formatted).format("YYYY-MM-DD");
            }
        },

        selectedDay() {
            // this.$store.dispatch("timer/getServerTime");
            this.getClassByDate(
                moment(this.selectedDay).format("DD/MM/YYYY"),
                teacher,
            );
            if (
                moment(this.startweek).startOf("week").format("DD MM YYYY") !==
                moment(this.selectedDay).startOf("week").format("DD MM YYYY")
            ) {
                this.keyaweek++;
            }
            this.changedOnDate = true;
            this.startweek = moment(this.selectedDay).startOf("week");
            setTimeout(() => {
                this.changedOnDate = false;
            }, 100);
        },
        "$route.query": {
            handler() {
                if (this.$route.query.id) {
                    this.getDetailClass(this.$route.query.id);
                }
            },
            deep: true,
            immediate: true,
        },
    },

    computed: {
        leftside() {
            var a = this.liveclasses;
            var b;
            if (this.$vuetify.breakpoint.mdAndUp) {
                b = _.chunk(a, 2);
            } else b = _.chunk(a, 1);
            return b;
        },

        allclasses() {
            return (
                _.chain(this.allclass)
                    // Group the elements of Array based on `color` property
                    .orderBy("startAt", "desc")
                    .groupBy("dimulai")
                    // `key` is group's name (color), `value` is the array of objects
                    .map((value, key) => ({ dimulai: key, classes: value }))
                    .value()
            );
        },
        premiclasses() {
            const kelases = this.semuakelas.filter(
                (live) =>
                    moment(live.startAt).format("YYYY-MM-DD") ===
                    moment(this.selectedDay).format("YYYY-MM-DD"),
            );
            return (
                _.orderBy(
                    kelases,
                    ["statusLive", "startAt"],
                    ["desc", "asc"],
                ) || []
            );
        },

        aweek() {
            const weekStart = this.startweek;

            const days = [];
            for (let i = 0; i <= 6; i++) {
                days.push(
                    moment(weekStart)
                        .add(i + this.startDay, "days")
                        .format("YYYY-MM-DD"),
                );
            }

            return days;
        },

        amonths() {
            const weekStart = moment().startOf("month");

            const days = [];
            for (let i = 0; i <= 4; i++) {
                days.push(moment(weekStart).add(i, "week"));
            }

            return days;
        },
    },

    mounted() {
        this.getTeachers();
        // this.$store.dispatch("timer/getServerTime");
        // this.getLiveClasses();
    },

    methods: {
        getTeachers() {
            const context = this;
            context.teachers = [];
            LiveClassTeacherService.getTeachers(function (result) {
                if (result.success) {
                    result.data.forEach(function (item) {
                        var row = {
                            id: item.id,
                            name: item.teacher_name,
                        };
                        context.teachers.push(row);
                    });
                }
            });
        },

        chooseTeacher(id) {
            this.getClassByDate(
                moment(this.selectedDay).format("DD/MM/YYYY"),
                id,
            );
        },

        openLink(url) {
            window.open(url, "_blank");
        },

        swipe(direction) {
            if (direction === 0) {
                this.startweek = moment(this.startweek).add(1, "week");
                this.keyaweek++;
            } else if (direction === 1) {
                this.startweek = moment(this.startweek).subtract(1, "week");
                this.keyaweek++;
            }
        },

        getDay(date) {
            const i = new Date(date).getDay(date);
            return this.daysOfWeek[i];
        },

        async getLiveClasses() {
            var context = this;
            // this.$store.dispatch("timer/getServerTime");
            context.semuakelas = [];
            LiveClassTeacherService.getLiveClassByTeacher(
                id,
                date,
                function (result) {
                    if (result.success) {
                        result.data.forEach((live) => {
                            var durationOP = moment(live.endAt).diff(
                                moment().valueOf(),
                            );
                            var durationCL = moment(live.startAt).diff(
                                moment().valueOf(),
                            );
                            var data = {
                                statusLive: durationOP > 0 && durationCL < 0,
                                liveclass_id: live.liveclass_id,
                                date: moment(live.startAt).format(
                                    "DD MMM, YYYY",
                                ),
                                name: live.name ? live.name : "-",
                                hours: `${moment(live.startAt).format("HH:mm")} - ${moment(
                                    live.endAt,
                                ).format("HH:mm")}`,
                                startAt: live.startAt,
                                endAt: live.endAt,
                                dimulai: moment(live.startAt).format(
                                    "DD MMM, YYYY",
                                ),

                                subject: live.subject,
                                teachers: tutors,
                                thumbnail: live.thumbnail,
                                liveClassRoomId: live.liveClassRoomId,
                            };
                            if (data.statusLive) {
                                livenow.push(data);
                            } else if (durationOP > 0) datas.push(data);
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data live class!`,
                            type: "error",
                        });
                    }
                    if (this.$route.query.id) {
                        setTimeout(() => {
                            this.getDetailClass(this.$route.query.id);
                        }, 2500);
                    }
                    this.classes = datas.filter((e) => e.type !== "PREMIUM");
                    this.liveclasses = livenow.filter(
                        (e) => e.type !== "PREMIUM",
                    );
                    this.loading = false;
                },
            );
        },

        async getClassByDate(date, id) {
            const context = this;
            // this.$store.dispatch("timer/getServerTime");

            context.semuakelas = [];
            LiveClassTeacherService.getLiveClassByTeacher(
                id,
                date,
                function (result) {
                    if (result.success) {
                        result.data.forEach(function (live) {
                            var durationOP = moment(live.endAt).diff(
                                moment().valueOf(),
                            );
                            var durationCL = moment(live.startAt).diff(
                                moment().valueOf(),
                            );

                            var arrTeacher = [];
                            var tutors = "";
                            live.teachers.forEach(function (item) {
                                var row = item.teacher_name;
                                arrTeacher.push(row);
                                tutors = arrTeacher.join(", ");
                            });
                            var data = {
                                statusLive: durationOP > 0 && durationCL < 0,
                                liveclass_id: live.liveclass_id,
                                date: moment(live.startAt).format(
                                    "DD MMM, YYYY",
                                ),
                                name: live.name ? live.name : "-",
                                hours: `${moment(live.startAt).format("HH:mm")} - ${moment(
                                    live.endAt,
                                ).format("HH:mm")}`,
                                startAt: live.startAt,
                                endAt: live.endAt,
                                dimulai: moment(live.startAt).format(
                                    "DD MMM, YYYY",
                                ),

                                subject: live.subject,
                                teachers: tutors,
                                thumbnail: live.thumbnail,
                                liveClassRoomId: live.liveClassRoomId,
                            };
                            context.semuakelas.push(data);
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data live class!`,
                            type: "error",
                        });
                    }
                },
            );
            this.loading = false;
        },

        async getDetailClass(id) {
            const context = this;

            context.selectedClass = [];
            context.selectedClass = context.semuakelas.find(function (elemen) {
                return elemen.liveclass_id == id;
            });

            context.$emit("selected", context.selectedClass);
            context.$store.commit(
                "live_class_teacher_init",
                context.selectedClass,
            );

            context.$router.push({
                path: "live-class-teacher-detail",
                query: { id: id },
            });
            this.loading = false;
        },

        checklive(item) {
            // this.$store.dispatch("timer/getServerTime");
            var durationCL = this.$moment(item.startAt).diff(
                this.$moment().valueOf(),
            );
            if (item.statusLive || durationCL > 0) this.live = true;
            else this.live = false;
            // if (this.selected === 1) {
            //   this.ispremiumclass = true;
            // }
            this.getDetailClass(item.liveclass_id);
        },

        recheckClass() {
            this.getLiveClasses();
            this.getClassByDate(moment(this.selectedDay).format("DD/MM/YYYY"));
        },

        clearDetail() {
            this.$router.replace({ query: null });
            this.selectedClass = {};
            if (this.selected) {
                this.semuakelas = [];
                this.getClassByDate(
                    moment(this.selectedDay).format("DD/MM/YYYY"),
                );
            } else this.getLiveClasses();
        },
    },
};
</script>

<style scoped>
.btmborder-group .v-tabs-bar__content {
    border-bottom-style: solid;
    border-bottom-width: 1px !important;
    border-bottom-color: #ebebeb !important;
}
.group-noborder {
    border: none !important;
}
.v-tabs-slider {
    background: #2690cb !important;
    border-radius: 111px !important;
}
.v-slide-group__prev {
    display: none !important;
}
.v-slide-group__next {
    display: none !important;
}
.xxsmall {
    width: 25px !important;
    height: 25px !important;
}
.v-item-group >>> .v-window__prev,
.v-item-group >>> .v-window__next {
    margin: 10px 0 0 0 !important;
    background-color: #f4f9f9;
}

.timeline-class >>> .v-timeline--dense:before {
    left: 74px;
    border-left: 2px dashed white;
}
.timeline-class >>> .v-timeline-item__divider {
    width: 42px !important;
    min-width: 42px !important;
}
.timeline-class >>> .v-timeline-item {
    width: 100%;
}

.timeline-class >>> .v-timeline-item__dot {
    margin-top: 3px !important;
}

.timeline-class >>> .v-timeline-item__opposite {
    display: inline-block;
    flex: none;
    height: 100% !important;
    text-align: right;
    width: 36px !important;
}

.timeline-class >>> .v-timeline-item__opposite {
    align-self: top !important;
    margin-bottom: auto !important;
}
@media (max-width: 960px) {
    .timeline-class >>> .v-timeline--dense:before {
        left: 74px;
    }
    .timeline-class >>> .v-timeline-item__divider {
        width: 22px !important;
    }
}

.hscroll::-webkit-scrollbar {
    display: none;
}
</style>



// WEBPACK FOOTER //
// LiveClassTeacher.vue?a4860608